import { render, staticRenderFns } from "./CreateDomiUser.vue?vue&type=template&id=35cccc27&scoped=true&"
import script from "./CreateDomiUser.vue?vue&type=script&lang=js&"
export * from "./CreateDomiUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cccc27",
  null
  
)

export default component.exports